<fa-icon
	id="{{ componentId }}-tooltip"
	class="vtr-ui-question-mark-button"
	[attr.role]="componentRole"
	[attr.aria-label]="ariaLabel"
	[tabindex]="tabIndex"
	[matPopupTriggerFor]="tooltipReference ?? tooltipRef"
	[ngClass]="{ 'gray-icon': isGray }"
	[icon]="['far', 'question-circle']"
></fa-icon>

<mat-menu
	#tooltipRef
	[hasBackdrop]="false"
	class="vtr-tooltip question-mark-tooltip"
	[xPosition]="xTooltipPosition"
	[yPosition]="yTooltipPosition">
	<div mat-menu-item id="{{ tooltipId }}">
		{{ tooltipText }}
	</div>
</mat-menu>
